export const PAYMENT_METHOD = {
  ONLINE: 'online',
  CASH_ON_DELIVERY: 'cash_on_delivery',
}

export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  PAID: 'PAID',
}

export const PAYMENT_PAY_TO = {
  COURIER: 'courier',
}

const LEGACY_CASH_IDS = new Set(['cash', 'CASH', 'CASH_ON_DELIVERY'])

export function toApiPaymentMethod(selectedId) {
  if (selectedId == null || selectedId === '') {
    return PAYMENT_METHOD.ONLINE
  }
  const value = String(selectedId)
  if (value === PAYMENT_METHOD.CASH_ON_DELIVERY || LEGACY_CASH_IDS.has(value)) {
    return PAYMENT_METHOD.CASH_ON_DELIVERY
  }
  return PAYMENT_METHOD.ONLINE
}

export function isCashOnDelivery(paymentMethod, payTo) {
  if (payTo === PAYMENT_PAY_TO.COURIER) {
    return true
  }
  if (paymentMethod == null || paymentMethod === '') {
    return false
  }
  return toApiPaymentMethod(paymentMethod) === PAYMENT_METHOD.CASH_ON_DELIVERY
}

export function isCashOnDeliveryPending(order) {
  if (!order || !isCashOnDelivery(order.paymentMethod ?? order.payment_method, order.payTo ?? order.pay_to)) {
    return false
  }
  const status = String(order.paymentStatus ?? order.payment_status ?? '').toUpperCase()
  return status !== PAYMENT_STATUS.PAID
}

export function shouldOpenOnlinePaymentQr(order) {
  if (!order) {
    return false
  }
  return !isCashOnDelivery(order.paymentMethod ?? order.payment_method, order.payTo ?? order.pay_to)
}

function asNullableString(value) {
  const text = String(value ?? '').trim()
  return text || null
}

function mapPaymentReceipt(raw) {
  const source = raw && typeof raw === 'object' ? raw : {}
  const amountRaw = source.amount
  const amount =
    amountRaw != null && amountRaw !== '' && Number.isFinite(Number(amountRaw))
      ? Number(amountRaw)
      : null
  const payer = source.payer && typeof source.payer === 'object' ? source.payer : {}

  return {
    provider: asNullableString(source.provider)?.toLowerCase() ?? null,
    amount,
    currency: asNullableString(source.currency)?.toLowerCase() ?? null,
    providerStatus: asNullableString(source.provider_status)?.toUpperCase() ?? null,
    externalId: asNullableString(source.external_id),
    paidAt: source.paid_at ?? null,
    payer: {
      fullname: asNullableString(payer.fullname),
      phone: asNullableString(payer.phone),
    },
  }
}

export function mapOrderPaymentFields(payload) {
  const totalPrice = Number(payload?.total_price ?? 0)
  const deliveryFee = Number(payload?.delivery_fee ?? 0)
  const amountDueRaw = payload?.amount_due
  const payTo = payload?.pay_to != null ? String(payload.pay_to) : null
  const paymentMethod = payload?.payment_method
    ? toApiPaymentMethod(payload.payment_method)
    : payTo === PAYMENT_PAY_TO.COURIER
      ? PAYMENT_METHOD.CASH_ON_DELIVERY
      : PAYMENT_METHOD.ONLINE

  return {
    paymentMethod,
    paymentStatus: payload?.payment_status != null ? String(payload.payment_status) : null,
    amountDue:
      amountDueRaw != null && Number.isFinite(Number(amountDueRaw))
        ? Number(amountDueRaw)
        : totalPrice + deliveryFee,
    payTo,
    paymentCollectedAt: payload?.payment_collected_at ?? null,
    paymentReceipt: mapPaymentReceipt(payload?.payment_receipt),
  }
}
